(function(){'use strict';

function $id(id){return document.getElementById(id);}
function getNum(id){var el=$id(id);return el?parseFloat(el.value):NaN;}
function getStr(id){var el=$id(id);return el?el.value:'';}
function setText(id,v){var el=$id(id);if(el)el.textContent=v;}
function show(id){var el=$id(id);if(el)el.classList.remove('fap-hidden');}

function animCount(el,target,decimals,duration){
  if(!el)return;
  var steps=40,current=0,increment=target/steps;
  var t=setInterval(function(){
    current+=increment;
    if(current>=target){current=target;clearInterval(t);}
    el.textContent=current.toFixed(decimals);
  },duration/steps);
}

function showResult(resultId,values){
  var res=$id(resultId);
  if(!res)return;
  res.classList.remove('fap-hidden');
  res.classList.add('fap-result-animate');
  setTimeout(function(){res.classList.remove('fap-result-animate');},500);
  Object.keys(values).forEach(function(key){
    var cell=$id(key);
    if(!cell)return;
    var v=values[key];
    if(typeof v==='number'){
      animCount(cell,v,(v===Math.round(v)?0:1),500);
    } else {
      cell.textContent=v;
      cell.classList.add('fap-val-pop');
      setTimeout(function(){cell.classList.remove('fap-val-pop');},400);
    }
  });
  setTimeout(function(){res.scrollIntoView({behavior:'smooth',block:'nearest'});},120);
}

function validate(fields){
  var ok=true;
  fields.forEach(function(id){
    var el=$id(id);
    if(!el)return;
    var v=parseFloat(el.value);
    if(isNaN(v)||v<=0){el.classList.add('fap-input-error');ok=false;}
    else{el.classList.remove('fap-input-error');}
  });
  return ok;
}

window.FAPCalc={

  imc:function(){
    if(!validate(['imc-weight','imc-height']))return;
    var w=getNum('imc-weight'),hm=getNum('imc-height')/100;
    var imc=w/(hm*hm);
    var cat,color;
    if(imc<16){cat='Denutrition severe';color='#e74c3c';}
    else if(imc<18.5){cat='Insuffisance ponderale';color='#e67e22';}
    else if(imc<25){cat='Poids normal OK';color='#2ecc71';}
    else if(imc<30){cat='Surpoids';color='#f39c12';}
    else if(imc<35){cat='Obesite moderee';color='#e67e22';}
    else{cat='Obesite severe';color='#e74c3c';}
    showResult('imc-result',{'imc-value':+imc.toFixed(1)});
    var catEl=$id('imc-category');
    if(catEl){catEl.textContent=cat;catEl.style.color=color;}
    var gauge=$id('imc-gauge-fill');
    if(gauge){var pct=Math.min(100,Math.max(0,((imc-10)/40)*100));setTimeout(function(){gauge.style.width=pct+'%';gauge.style.background=color;},200);}
  },

  lbm:function(){
    if(!validate(['lbm-weight','lbm-height']))return;
    var w=getNum('lbm-weight'),h=getNum('lbm-height'),g=getStr('lbm-gender');
    var lbm=g==='femme'?(0.252*w)+(0.473*h)-48.3:(0.407*w)+(0.267*h)-19.2;
    var fat=Math.max(0,w-lbm),fatPct=fat/w*100;
    showResult('lbm-result',{'lbm-value':lbm.toFixed(1)+' kg','fat-mass':fat.toFixed(1)+' kg','fat-pct':fatPct.toFixed(1)+'%'});
    var barL=$id('lbm-bar-lbm'),barF=$id('lbm-bar-fat');
    if(barL&&barF){setTimeout(function(){barL.style.width=(lbm/w*100).toFixed(1)+'%';barF.style.width=fatPct.toFixed(1)+'%';},200);}
  },

  whr:function(){
    if(!validate(['whr-waist','whr-hips']))return;
    var waist=getNum('whr-waist'),hips=getNum('whr-hips'),g=getStr('whr-gender');
    var ratio=waist/hips;
    var cat,color;
    if(g==='femme'){if(ratio<0.80){cat='Risque faible';color='#2ecc71';}else if(ratio<0.86){cat='Risque modere';color='#f39c12';}else{cat='Risque eleve';color='#e74c3c';}}
    else{if(ratio<0.90){cat='Risque faible';color='#2ecc71';}else if(ratio<1.0){cat='Risque modere';color='#f39c12';}else{cat='Risque eleve';color='#e74c3c';}}
    showResult('whr-result',{'whr-value':+ratio.toFixed(2)});
    var catEl=$id('whr-category');
    if(catEl){catEl.textContent=cat;catEl.style.color=color;}
  },

  rm:function(){
    if(!validate(['rm-weight','rm-reps']))return;
    var w=getNum('rm-weight'),r=getNum('rm-reps');
    if(r>30){$id('rm-reps').classList.add('fap-input-error');return;}
    var rm=w*(1+r/30);
    var lines=[100,95,90,85,80,75,70].map(function(p){return p+'% = '+(rm*p/100).toFixed(1)+' kg';}).join(' | ');
    showResult('rm-result',{'rm-value':rm.toFixed(1)+' kg','rm-percentages':lines});
  },

  volume:function(){
    if(!validate(['volume-sets','volume-reps','volume-weight']))return;
    var sets=getNum('volume-sets'),reps=getNum('volume-reps'),w=getNum('volume-weight');
    var vol=sets*reps*w;
    showResult('volume-result',{'volume-value':vol.toFixed(0)+' kg','volume-details':sets+' series x '+reps+' reps x '+w+' kg'});
  },

  calories:function(){
    if(!validate(['cal-weight','cal-height','cal-age']))return;
    var w=getNum('cal-weight'),h=getNum('cal-height'),age=getNum('cal-age');
    var g=getStr('cal-gender'),act=parseFloat(getStr('cal-activity'));
    var bmr=g==='femme'?(10*w)+(6.25*h)-(5*age)-161:(10*w)+(6.25*h)-(5*age)+5;
    var tdee=bmr*act;
    showResult('cal-result',{
      'cal-bmr':Math.round(bmr)+' kcal',
      'cal-loss':Math.round(tdee-400)+' kcal',
      'cal-maintain':Math.round(tdee)+' kcal',
      'cal-gain':Math.round(tdee+400)+' kcal'
    });
  },

  proteines:function(){
    if(!validate(['prot-weight']))return;
    var w=getNum('prot-weight'),factor=parseFloat(getStr('prot-goal'));
    showResult('prot-result',{
      'prot-min':(w*(factor-0.2)).toFixed(0)+' g/j',
      'prot-max':(w*factor).toFixed(0)+' g/j',
      'prot-per-meal':(w*factor/4).toFixed(0)+' g/repas'
    });
  },

  cardio:function(){
    if(!validate(['cardio-age']))return;
    var age=getNum('cardio-age'),rest=getNum('cardio-rest');
    var fcmax=220-age;
    var zones=[
      {name:'Zone 1 - Recuperation active',pmin:50,pmax:60},
      {name:'Zone 2 - Endurance fondamentale',pmin:60,pmax:70},
      {name:'Zone 3 - Aerobie / Fat burn',pmin:70,pmax:80},
      {name:'Zone 4 - Seuil anaeroe',pmin:80,pmax:90},
      {name:'Zone 5 - Effort maximal',pmin:90,pmax:100}
    ];
    var tbody=$id('cardio-rows');
    if(!tbody)return;
    tbody.innerHTML='';
    zones.forEach(function(z){
      var min,max;
      if(!isNaN(rest)&&rest>0&&rest<fcmax){
        min=Math.round(rest+(fcmax-rest)*z.pmin/100);
        max=Math.round(rest+(fcmax-rest)*z.pmax/100);
      } else {
        min=Math.round(fcmax*z.pmin/100);
        max=Math.round(fcmax*z.pmax/100);
      }
      var tr=document.createElement('tr');
      tr.innerHTML='<td>'+z.name+'</td><td><strong>'+min+' - '+max+'</strong> bpm</td>';
      tbody.appendChild(tr);
    });
    show('cardio-result');
    setText('cardio-fcmax','FC Max estimee : '+fcmax+' bpm');
  }
};

document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.fap-input').forEach(function(el){
    el.addEventListener('input',function(){el.classList.remove('fap-input-error');});
    el.addEventListener('keydown',function(e){
      if(e.key==='Enter'){
        var card=el.closest('.fap-card');
        if(card){var btn=card.querySelector('.fap-btn');if(btn)btn.click();}
      }
    });
  });
});

})();